export const CondicaoMap = new Map<string, string>([
	['muitoSeco', 'Muito seco'],
	['seco', 'Seco'],
	['normal', 'Normal'],
	['chuvoso', 'Chuvoso'],
	['muitoChuvoso', 'Muito chuvoso'],
	['observado', 'Observado'],
]);
